import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {SharedModule} from './components/shared.module';
import {LandingComponent} from './modules/user/landing/landing.component';
import {IntroComponent} from './modules/intro/intro.component';
import {OnBoardingComponent} from './modules/user/on-boarding/on-boarding.component';
import {InvisibleCityComponent} from './modules/user/projects/invisible-city/invisible-city.component';
import {ReadMoreComponent} from './modules/user/projects/invisible-city/read-more/read-more.component';
import {AddReportComponent} from './modules/user/auth/reports/add-report/add-report.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IntroReadMoreComponent} from './modules/intro/intro-read-more.component';
import {ErrorInterceptor} from './_helpers/error.interceptor';
import {YouActAddReportComponent} from './modules/user/auth/reports/you-act-add-report/you-act-add-report.component';
import {MapLandingComponent} from './modules/tabs/map-landing/map-landing.component';
import {AuthModule} from './modules/user/auth/auth.module';
import {HandleWildCardComponent} from './components/handle-wild-card.component';
import {SurveyComponent} from './modules/user/auth/reports/survey/survey.component';
import {AtomTextIconLabelComponent} from './components/atom-text/why-input.component';
import {FeedbackComponent} from './components/feedback/feedback.component';
import {MapFilterComponent} from './modules/tabs/map-landing/map-filter/map-filter.component';
import {AddSiteComponent} from './components/add-site/add-site.component';

export const createTranslateLoader = (http: HttpClient): any => new TranslateHttpLoader(http);


@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    IntroComponent,
    InvisibleCityComponent,
    ReadMoreComponent,
    OnBoardingComponent,
    AddReportComponent,
    YouActAddReportComponent,
    IntroReadMoreComponent,
    MapLandingComponent,
    HandleWildCardComponent,
    SurveyComponent,
    MapFilterComponent,
    FeedbackComponent,
    AtomTextIconLabelComponent,
    AddSiteComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader, // exported factory function needed for AoT compilation
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    SharedModule,
    AuthModule,
  ],
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true}
  ],
  bootstrap: [AppComponent],
    exports: [
        AtomTextIconLabelComponent
    ]
})
export class AppModule {
}
